module.exports = __webpack_public_path__ + "static/metalang-40bfaece9573298ace2531685a45f068.png";